import React, { useId } from 'react';
import { Modal } from '@/shared/components';
import { Button } from '@shared/components';
import { XIcon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';

interface ErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    status?: number;
    canRetry?: boolean;
    onRetry?: () => void;
}

export const QuoteErrorModal: React.FC<ErrorModalProps> = ({
    isOpen,
    onClose,
    title,
    message,
    status,
    canRetry = false,
    onRetry,
}) => {
    const headingId = useId();

    const getErrorIcon = () => {
        if (status === 403) return <OctagonXIcon className="text-mp-error w-8 h-8" />;
        if (status === 422) return <TriangleAlertIcon className="text-mp-warning w-8 h-8" />;
        return <XIcon className="text-mp-error w-8 h-8" />;
    };

    const getErrorColor = () => {
        if (status === 403) return 'text-mp-error';
        if (status === 422) return 'text-mp-warning';
        return 'text-mp-error';
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={true}
            ariaLabelledBy={headingId}
            className="max-w-md mx-auto mt-20"
        >
            <div className="p-4">
                <div className="flex items-center mb-4">
                    <span className="text-3xl mr-3">{getErrorIcon()}</span>
                    <h2 id={headingId} className={`text-xl font-semibold ${getErrorColor()}`}>{title}</h2>
                </div>

                <div className="mb-6">
                    <p className="text-mp-foreground mb-2">{message}</p>
                    {status && <p className="text-sm text-mp-muted">Error Code: {status}</p>}
                </div>

                <div className="flex justify-end space-x-3">
                    {canRetry && onRetry && (
                        <Button onClick={onRetry} variant="secondary">
                            Try Again
                        </Button>
                    )}
                    <Button onClick={onClose} variant="primary">
                        OK
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
